// Take an image source that fails to load and replace it with a
// coming soon placeholder image
const comingSoon = (event) => {
  event.target.src = require('../../assets/images/coming_soon.png')
}

export default comingSoon;